import HTTP from '@/utils/http';

const defaultState = () => ({
    userMfa: null,
});

const mfaModule = {
    namespaced: true,
    state: defaultState(),
    mutations: {
        RESET_STATE(state) {
            Object.assign(state, defaultState());
        },
        SET_USER_MFA(state, { userMfa }) {
            state.userMfa = userMfa;
        },
    },
    actions: {
        RESET_STATE({ commit }) {
            commit('RESET_STATE');
        },
        GET({ commit }) {
            return HTTP({
                url: 'users/multi-factor-auth',
                suppressServerErrors: true,
            }).then((response) => {
                commit('SET_USER_MFA', { userMfa: response.data.data });
            }).catch(() => {
                // Fallthrough
            });
        },
        DELETE({ commit }, password) {
            return HTTP({
                method: 'delete',
                url: 'users/multi-factor-auth',
                data: {
                    password,
                },
            }).then(() => {
                commit('SET_USER_MFA', {});
            });
        },
        CREATE({ commit }) {
            return HTTP({
                method: 'post',
                url: 'users/multi-factor-auth',
                data: {
                    type: 'totp',
                    frequency: 'everytime',
                },
            }).then((response) => {
                commit('SET_USER_MFA', { userMfa: response.data.data });
            });
        },
        CREATE_RECOVERY_CODE(context, data) {
            return HTTP({
                method: 'post',
                url: 'users/multi-factor-auth/recovery-codes',
                data,
            });
        },
        VERIFY({ commit }, { code }) {
            return HTTP({
                method: 'post',
                url: 'users/multi-factor-auth/verify',
                data: {
                    code,
                },
            }).then((response) => {
                commit('SET_USER_MFA', { userMfa: response.data.data });
            });
        },
        VALIDATE({ commit }, { code }) {
            return HTTP({
                method: 'post',
                url: 'multi-factor-auth/validate',
                data: {
                    code,
                },
            }).then((response) => {
                commit('SET_USER_MFA', { userMfa: response.data.data });
            });
        },
        DELETE_MFA_FOR_USER(context, user) {
            return HTTP({
                method: 'delete',
                url: `users/${user.id}/multi-factor-auth`,
            });
        },
        CREATE_RECOVERY_CODE_FOR_USER(context, user) {
            return HTTP({
                method: 'post',
                url: `users/${user.id}/multi-factor-auth/recovery-codes`,
            });
        },
        GET_MFA_FOR_USER(context, user) {
            return HTTP({
                method: 'get',
                url: `users/${user.id}/multi-factor-auth`,
                suppressAllErrors: true,
            });
        },
        VALIDATE_RECOVERY_CODE(context, { code }) {
            return HTTP({
                method: 'post',
                url: 'multi-factor-auth/recovery-codes/validate',
                data: {
                    code,
                },
            });
        },
    },
    getters: {
        userMfa: state => state.userMfa,
        mfaAuthenticationRequired: state => (state.userMfa ? state.userMfa.verified && state.userMfa.authentication_required : false),
        mfaSetupRequired: (state, getters, rootState, rootGetters) => {
            if (rootGetters['company/mfaEnabled']) {
                return !state.userMfa?.verified && rootGetters['user/user'].user_last_login > rootGetters['company/companyMFA'].mfa_enabled_at;
            }
            return false;
        },
        mfaActionRequired: (state, getters) => getters.mfaAuthenticationRequired || getters.mfaSetupRequired,
    },
};

export default mfaModule;
